import { render, staticRenderFns } from "./GroupCommentReply.vue?vue&type=template&id=076d5f12&scoped=true"
import script from "./GroupCommentReply.vue?vue&type=script&lang=js"
export * from "./GroupCommentReply.vue?vue&type=script&lang=js"
import style0 from "./GroupCommentReply.vue?vue&type=style&index=0&id=076d5f12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d5f12",
  null
  
)

export default component.exports